<ion-grid class="single-select-mobile">
  <div (click)="dismissModal()" class="single-select-mobile__close-btn"></div>
  <ion-row class="single-select-mobile__title-row">
    <ion-col size="12" *ngIf="title">{{ title | translate }}</ion-col>
  </ion-row>
  <ion-row *ngIf="statusConf">
    <div *ngFor="let status of uniqueStatusConf" class="single-select-mobile__legend">
      <div class="single-select-mobile__legend-icon" [style.background-color]="status.color"></div>
      <div class="single-select-mobile__legend-text">{{ status.type | translate }}</div>
    </div>
  </ion-row>
  <ion-row *ngIf="statusConf" class="single-select-mobile__search-row">
    <div class="single-select-mobile__search-icon"></div>
    <ion-col size="11">
      <ion-input
        type="text"
        [placeholder]="'single_select.SearchEmployee' | translate"
        [(ngModel)]="searchTerm"
        (ionChange)="filterOptions()"
      ></ion-input>
    </ion-col>
  </ion-row>
  <div
    class="single-select-mobile__item-container"
    [ngClass]="{ 'single-select-mobile__item-container--with-status': statusConf }"
  >
    <div *ngFor="let option of filteredOptionList; let i = index">
      <div class="single-select-mobile__item" (click)="changeSelected(option)">
        <div
          class="single-select-mobile__item-content"
          [ngClass]="{ 'single-select-mobile__item--selected': option.key === currentSelected }"
        >
          <div
            *ngIf="statusConf"
            class="single-select-mobile__status-icon"
            [style.background-color]="filteredStatusConf[i].color"
          ></div>
          {{ option.displayName | translate }} {{ statusConf && showOptionKey ? '(' + option.key + ')' : undefined }}
        </div>

        <div *ngIf="option.key === currentSelected" class="single-select-mobile__selected-icon"></div>
      </div>
    </div>
  </div>
  <div>
    <ion-row class="single-select-mobile__btn-row">
      <ion-col *ngIf="hasClear" size="6" class="single-select-mobile__cancel-btn">
        <ui-custom-button
          [buttonType]="'SECONDARY'"
          [btnTxt]="'single_select.Clear' | translate"
          [expand]="'block'"
          (clickEvent)="clearFilter()"
        ></ui-custom-button>
      </ion-col>
      <ion-col [size]="hasClear ? '6' : '12'" class="single-select-mobile__apply-btn">
        <ui-custom-button
          [buttonType]="'PRIMARY'"
          [btnTxt]="'single_select.Apply' | translate"
          [expand]="'block'"
          (clickEvent)="applyFilter()"
        ></ui-custom-button
      ></ion-col>
    </ion-row>
  </div>
</ion-grid>
